module.exports = __webpack_public_path__ + "img/rouge-blue.e99b840b.webp";